import {
	RECEIVE_COMMENT,
} from '../action/comment'

const initialState = {
	comments: null,
}

export default(state = initialState, action) => {
	switch(action.type){
		case RECEIVE_COMMENT:
			return {
				...state,
				comments: action.comments
			}
		default: 
			return state
	}
}